export default __webpack_public_path__ + "static/ScalingWithIconWrong-c466247c30ac39dc11e4bbbe601146b7.png";